const style = (theme) => {
  const output = {
    titleLine: {
      position: 'relative',
      '& span': {
        zIndex: 1,
      },
    },
    img: {
      opacity: 0,
      transition: `opacity 1s ${theme.easings['power4.out']}`,
      '&.is-inview': {
        opacity: '1',
      },
    },
    img1: {
      position: 'absolute',
      top: '10vh',
      left: '2vw',
      zIndex: 0,
      width: '35vw',
    },
    img2: {
      position: 'absolute',
      top: '-10vh',
      right: 0,
      zIndex: 0,
      width: '26vw',
    },
    nativeScroll: {
      '& $img': {
        opacity: '1',
      },
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
